import { toast } from "@/hooks/use-toast";
import { useInternalUserByEmail } from "@/features/internal-user/hooks/use-internal-user";
import { useState } from "react";
import { placeExotelCall } from "../services/exotel";

export function useContactActions() {
  const { data: currentUser } = useInternalUserByEmail();
  const [calling, setCalling] = useState(false);

  const hasExotelPhone = !!currentUser?.exotel_phone_number;

  const callViaExotel = async (phone: string) => {
    if (!phone) return;
    setCalling(true);
    try {
      await placeExotelCall(phone);
      toast({
        title: "Call initiated",
        description: "Your phone will ring first, then the patient's.",
      });
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Call failed";
      toast({ title: "Call failed", description: msg, variant: "destructive" });
    } finally {
      setCalling(false);
    }
  };

  const openWatiChat = (phone: string) => {
    if (!phone) return;
    const cleanPhone = phone.replace(/[^0-9]/g, "");
    const base =
      (import.meta.env.VITE_WATI_TEAM_INBOX_URL as string) ||
      "https://live.wati.io/113310/teamInbox";
    const filter = `{"channelType":2,"filterType":0,"filterId":0}`;
    const search = `{"searchString":"${cleanPhone}","searchOptionType":4,"searchTimeRange":4}`;
    window.open(
      `${base}?filter=${filter}&search=${search}`,
      "_blank",
      "noopener",
    );
  };

  return { callViaExotel, openWatiChat, calling, hasExotelPhone };
}
